import { gql } from '@apollo/client';

/**
 * Passwordless phone + OTP authentication.
 *
 * Flow: SIMPLE_SIGNUP (sends/triggers OTP) -> VERIFY_OTP_AND_LOGIN (returns token + user).
 * SIMPLE_SIGNUP_SUBSCRIPTION can be used to receive the OTP over the websocket
 * transport in environments where it is delivered that way.
 */

export const SIMPLE_SIGNUP = gql`
  mutation SimpleSignup($phone: String!, $referralCode: String, $fullName: String) {
    simpleSignup(input: { phone: $phone, referralCode: $referralCode, fullName: $fullName }) {
      success
      message
      requiresOtp
      phone
      otp
      errors {
        code
        field
        message
      }
    }
  }
`;

export const VERIFY_OTP_AND_LOGIN = gql`
  mutation VerifyOtpAndLogin($phone: String!, $otp: String!) {
    verifyOtpAndLogin(input: { phone: $phone, otp: $otp }) {
      success
      message
      otp
      token {
        tokenType
        refreshToken
        expiresIn
        authToken
      }
      user {
        id
        fullName
        email
        phone
        isVendor
        isActive
        canSell
        city
        country
        currentMode
        username
        userType
      }
    }
  }
`;

export const SIMPLE_SIGNUP_SUBSCRIPTION = gql`
  subscription SimpleSignupSubscription($phone: String!, $referralCode: String) {
    simpleSignupSubscription(input: { phone: $phone, referralCode: $referralCode }) {
      otp
      phone
      status
      success
      error {
        code
        field
        message
      }
    }
  }
`;
